// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__avegZ","numbers":"Counter_numbers__5r8U1"};